cobalt-select {
  display: block;
}

cobalt-select .select-format--aside .select-header {
  min-height: 2.25rem;
}

cobalt-select .core-select:not(.core-select.select-format--inside) .icon-box {
  padding: var(--number-spacing-none);
}

cobalt-select .core-select.core-select:not(.core-select.select-format--inside) .field-indicator .icon-box:not(cobalt-select .core-select .field-indicator .icon-box:last-child) {
  padding-right: var(--number-spacing-4xsmall);
}

.core-select-option-list .option {
  padding: var(--number-spacing-3xsmall);
}

.core-select-option-list .icon-box {
  padding: var(--number-spacing-none);
}
